import { useEffect, useMemo } from 'react';
import { useApiUrl } from '../../global/config/useApiUrl';
import { useCampfireFetch } from '../../global/network/useCampfireFetch';

export interface VolunteerBusyTime {
  date: string;
  startTime: string;
  endTime: string;
  activityName: string;
  sessionName: string;
}

interface BusyTimesResponse {
  busyTimes: VolunteerBusyTime[];
}

export function useVolunteerBusyTimes(dates: string[], excludeActivityId?: string, enabled = true) {
  const apiUrl = useApiUrl();
  const campfireFetch = useCampfireFetch<BusyTimesResponse>({ defer: true });

  const range = useMemo(() => {
    if (!enabled || dates.length === 0) return undefined;
    const sorted = [...dates].sort();
    return { dateFrom: sorted[0], dateUntil: sorted[sorted.length - 1] };
  }, [enabled, dates]);

  const rangeKey = `${range?.dateFrom ?? ''}|${range?.dateUntil ?? ''}|${excludeActivityId ?? ''}`;

  useEffect(() => {
    if (!range) return;

    campfireFetch.run({
      url: `${apiUrl}/vm/activity/roster/busy-times`,
      method: 'POST',
      data: {
        dateFrom: range.dateFrom,
        dateUntil: range.dateUntil,
        excludeActivityId,
      },
    });
  }, [rangeKey, apiUrl]);

  const busyTimes = useMemo(() => {
    return campfireFetch.response?.data?.data?.busyTimes ?? [];
  }, [campfireFetch.response]);

  return { busyTimes, isLoading: campfireFetch.isLoading, error: campfireFetch.error };
}
